import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold leading-9 mb-3" }
const _hoisted_2 = { class: "text-sm mb-6" }
const _hoisted_3 = { class: "font-medium leading-9 mb-3" }
const _hoisted_4 = { class: "text-sm mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-medium leading-9 mb-3" }
const _hoisted_8 = { class: "text-sm mb-6" }
const _hoisted_9 = { class: "max-w-xl" }
const _hoisted_10 = { class: "text-sm font-bold text-dark-2 mb-2" }
const _hoisted_11 = { class: "flex items-start" }
const _hoisted_12 = { class: "font-medium leading-9 mb-3" }
const _hoisted_13 = { class: "text-sm mb-6" }
const _hoisted_14 = { class: "flex justify-start mt-4 flex-wrap" }
const _hoisted_15 = { class: "flex justify-start mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_section = _resolveComponent("app-section")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_upload = _resolveComponent("app-upload")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_app_input = _resolveComponent("app-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { padding: "8" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("pages.settings.brand.header")), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("pages.settings.brand.headerText")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, {
      padding: "8",
      class: "border-b border-light-3 pb-8"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("pages.settings.brand.logoHeader")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t("pages.settings.brand.logoText")), 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("pages.settings.brand.logoTextTip")), 1)
        ]),
        _createVNode(_component_app_upload, {
          onUpload: _ctx.uploadLogo,
          onRemove: _ctx.remove,
          reset: _ctx.logoReset
        }, _createSlots({ _: 2 }, [
          (_ctx.showLogo)
            ? {
                name: "dropArea",
                fn: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "max-h-24",
                    src: _ctx.logo.value
                  }, null, 8, _hoisted_6),
                  _createVNode(_component_app_button, {
                    "button-style": "transparentUnderline",
                    onClick: _ctx.resetLogo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("general.replace")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["onUpload", "onRemove", "reset"])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, {
      padding: "8",
      class: "border-b border-light-3 pb-8 mt-6"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("pages.settings.brand.colorHeader")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("pages.settings.brand.colorText")), 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandColors, (_, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mb-4"
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(index === 0
                            ? _ctx.$t("pages.settings.brand.mainColor")
                            : _ctx.$t("pages.settings.brand.additionalColor", {
                                  number: index
                              })), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_color_picker, {
                  modelValue: _ctx.brandColors[index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.brandColors[index]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_app_input, {
                  modelValue: _ctx.brandColors[index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.brandColors[index]) = $event),
                  prefix: "#",
                  limit: 6,
                  class: "mr-4",
                  status: _ctx.isBrandColorInvalid(index) ? 'error' : '',
                  description: 
                            _ctx.isBrandColorInvalid(index)
                                ? _ctx.$t('pages.settings.brand.invalidColor')
                                : ''
                        
                }, null, 8, ["modelValue", "onUpdate:modelValue", "status", "description"]),
                (index > 0 && _ctx.brandColors[index])
                  ? (_openBlock(), _createBlock(_component_app_button, {
                      key: 0,
                      "button-style": "transparentUnderline",
                      onClick: ($event: any) => (_ctx.clearBrandColor(index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("pages.settings.brand.clearColor")), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createVNode(_component_app_button, {
            "button-style": "primary",
            onClick: _ctx.changeColors
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, {
      padding: "8",
      class: "border-b border-light-3 pb-8 mt-6"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("pages.settings.brand.fontHeader")), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("pages.settings.brand.fontText")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_app_input, {
              label: "Font name",
              placeholder: "E.g. Poppins",
              class: "w-100 mr-6",
              modelValue: _ctx.customFontName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customFontName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              label: "Font stack",
              placeholder: "E.g. 'Poppins', sans-serif",
              class: "w-100",
              modelValue: _ctx.customFontFamily,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customFontFamily) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_app_input, {
              label: "Font CSS URL",
              placeholder: "E.g. https://fonts.googleapis.com/css2?family=Poppins",
              class: "w-100 mr-6",
              modelValue: _ctx.customFontCssUrl,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customFontCssUrl) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_app_button, {
            "button-style": "primary",
            class: "mt-4",
            onClick: _ctx.updateCustomFont
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}